import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { RootRoutes } from './app/RootRoutes';
import { startErrorTracking } from './lib/errorTracking';
import { injectTokenStyles } from './theme/cssVars';

void startErrorTracking();
injectTokenStyles();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <RootRoutes />
    </BrowserRouter>
  </StrictMode>,
);
// selective build test
